// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicInfo_basicinfo__m5pkM {
  width: 661px;
  min-height: 250px;
  padding: 25px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 5px 5px 10px #d5d5d5, -5px -5px 10px #ebebeb;
}
.BasicInfo_infoDetals__e8eTT {
  display: flex;
  justify-content: space-between;
}
.BasicInfo_infoHead__ECWbm {
  font-size: 20px;
  font-weight: bold;
}
.BasicInfo_EditButton__FgFi6 {
  position: relative;
  width: 36px;
  height: 36px;
  background-color: #efeeed;
  border-radius: 50px;
  padding: 50px 10px;
  cursor: pointer;
}
.BasicInfo_EditButton__FgFi6 img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.BasicInfo_BasicDetails__iL83h {
  padding-top: 10px;
  word-break: break-word;
}

.BasicInfo_EditDetails__nB-eI {
  padding-top: 20px;
}
.BasicInfo_EditDetails__nB-eI label {
  font-style: initial;
  font-weight: 700;
}
.BasicInfo_EditInputfeild__Ta0OT {
  width: 590px;
  margin: auto;
  margin-bottom: 20px;
}

.BasicInfo_EditInputfeild__Ta0OT input {
  width: 100%;
  border-radius: 50px;
  border: 2px solid grey;
  font-size: 16px;
  padding: 11px;
  padding-left: 18px;
}
.BasicInfo_EditName__CCjly {
  margin-left: 20px;
}
.BasicInfo_EditTextfeild__M707- {
  width: 590px;
  margin: auto;
  margin-bottom: 20px;
}
.BasicInfo_EditTextfeild__M707- textarea {
  width: 100%;
  border-radius: 20px;
  border: 2px solid grey;
  font-size: 16px;
  padding: 11px;
  padding-left: 18px;
}
.BasicInfo_SaveCancelButtonContainer__9VNZf {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.BasicInfo_SaveButton__H6pdJ {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);
  color: white;
  cursor: pointer;
}
.BasicInfo_cancelButton__bI\\+Mu {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background-color: transparent;
  cursor: pointer;
  outline: none !important;
}
.BasicInfo_errorMsg__ysHYe {
  visibility: visible;
  margin: 0px;
  padding-top: 5px;
  font-size: 12px;
  color: rgb(230, 79, 79);
  margin-left: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EditProfile/BasicInfo/BasicInfo.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAGT,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0EAA0E;EAC1E,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB","sourcesContent":[".basicinfo {\r\n  width: 661px;\r\n  min-height: 250px;\r\n  padding: 25px;\r\n  background-color: white;\r\n  border-radius: 20px;\r\n  box-shadow: 5px 5px 10px #d5d5d5, -5px -5px 10px #ebebeb;\r\n}\r\n.infoDetals {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.infoHead {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n.EditButton {\r\n  position: relative;\r\n  width: 36px;\r\n  height: 36px;\r\n  background-color: #efeeed;\r\n  border-radius: 50px;\r\n  padding: 50px 10px;\r\n  cursor: pointer;\r\n}\r\n.EditButton img {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n  -ms-transform: translate(-50%, -50%);\r\n  transform: translate(-50%, -50%);\r\n}\r\n.BasicDetails {\r\n  padding-top: 10px;\r\n  word-break: break-word;\r\n}\r\n\r\n.EditDetails {\r\n  padding-top: 20px;\r\n}\r\n.EditDetails label {\r\n  font-style: initial;\r\n  font-weight: 700;\r\n}\r\n.EditInputfeild {\r\n  width: 590px;\r\n  margin: auto;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.EditInputfeild input {\r\n  width: 100%;\r\n  border-radius: 50px;\r\n  border: 2px solid grey;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n  padding-left: 18px;\r\n}\r\n.EditName {\r\n  margin-left: 20px;\r\n}\r\n.EditTextfeild {\r\n  width: 590px;\r\n  margin: auto;\r\n  margin-bottom: 20px;\r\n}\r\n.EditTextfeild textarea {\r\n  width: 100%;\r\n  border-radius: 20px;\r\n  border: 2px solid grey;\r\n  font-size: 16px;\r\n  padding: 11px;\r\n  padding-left: 18px;\r\n}\r\n.SaveCancelButtonContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n.SaveButton {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n.cancelButton {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n  outline: none !important;\r\n}\r\n.errorMsg {\r\n  visibility: visible;\r\n  margin: 0px;\r\n  padding-top: 5px;\r\n  font-size: 12px;\r\n  color: rgb(230, 79, 79);\r\n  margin-left: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"basicinfo": `BasicInfo_basicinfo__m5pkM`,
	"infoDetals": `BasicInfo_infoDetals__e8eTT`,
	"infoHead": `BasicInfo_infoHead__ECWbm`,
	"EditButton": `BasicInfo_EditButton__FgFi6`,
	"BasicDetails": `BasicInfo_BasicDetails__iL83h`,
	"EditDetails": `BasicInfo_EditDetails__nB-eI`,
	"EditInputfeild": `BasicInfo_EditInputfeild__Ta0OT`,
	"EditName": `BasicInfo_EditName__CCjly`,
	"EditTextfeild": `BasicInfo_EditTextfeild__M707-`,
	"SaveCancelButtonContainer": `BasicInfo_SaveCancelButtonContainer__9VNZf`,
	"SaveButton": `BasicInfo_SaveButton__H6pdJ`,
	"cancelButton": `BasicInfo_cancelButton__bI+Mu`,
	"errorMsg": `BasicInfo_errorMsg__ysHYe`
};
export default ___CSS_LOADER_EXPORT___;
